import { React, useState } from "react";
import { Button, Form, Input, Select, Col, Row, Checkbox } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import { DatePicker } from "antd";
import {
  DatePickerY,
  GlobalSet,
  DisabledStyles,
  DeliveryaddressSpacing,
} from "../../pageStyled";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertBlue from '../../../Assets/Icons/alertBlue.svg';

const { Option } = Select;
const grainTypeData = ["Long Grain", "Short Grain"];
const deckleWidthUnitData = ["mm", "cm"];
const provinceData = ["India", "USA"];
const orderTypeData = ["Sheet", "Reel"];
const productSpecData = [
  "Kraft Paper / Corrugated Paper",
  "Duplex Coated Duplex Paper",
  "Writing and Printing Paper",
];
const currencyUnitData = ["US Dollor", "Rupees", "GB Pound"];

const cityData = {
  India: ["Arunachal Pradesh", "Andra Pradesh", "Bihar", "Chhattisgarh"],
  USA: ["Arizona", "California", "Colorado"],
};

const { TextArea } = Input;

const ViewApprovalOrderDrawer = (props) => {
  const [checkedBox, setCheckedBox] = useState(false);
  const [cities, setCities] = useState(cityData[provinceData[0]]);
  const [secondCity, setSecondCity] = useState(cityData[provinceData[0]][0]);
  const onChangeHandlerBox = (e) => {
    setCheckedBox(e.target.checked);
  };

  const handleProvinceChange = (value) => {
    setCities(cityData[value]);
    setSecondCity(cityData[value][0]);
  };
  const onSecondCityChange = (value) => {
    setSecondCity(value);
  };

  return (
    <RightDrawerSidebar
      title="Order Details - #1021"
      subtitle=""
      visible={props.visible}
      onClose={props.onCloseGrade}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <DetailFields className="marginBtnP">
            <HaberForm>
            <div
                className="drawerFieldAlert"
                style={{
                  paddingTop: 0,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="titleWithText"
                  style={{
                    marginBottom: 20,
                  }}
                >
                  <h5>Prioritized Order</h5>
                </div>
                {/* Priority Order means need to show this blue alert box */}
                <AlertContainer color="blue" icon={alertBlue} msg="This order is prioritized. This order will be fulfilled completely in the next deckle match" /> 
              </div>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
              >
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Order Number</h5>
                    <p>A unique auto-generated code to identify this order</p>
                  </div>
                  <Form.Item
                    name="Grade Name"
                    rules={[{ required: true }]}
                    className=""
                  >
                    <Input
                      disabled
                      placeholder="Enter PO Number"
                      defaultValue="ITC21082021"
                    />
                  </Form.Item>
                </div>

                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Product Specifications</h5>
                    <p>Combination of Grade/GSM/BF/Quality</p>
                  </div>
                  <Form.Item
                    name="Product Spec"
                    rules={[{}]}
                    className="selectForm"
                  >
                    <Select placeholder="Select" suffixIcon={<DownArrowDraw />}>
                      {productSpecData.map((productSpec) => (
                        <Option key={productSpec}>{productSpec}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Order type</h5>
                    <p>The order can be of reel or sheet type</p>
                  </div>
                  <Form.Item
                    name="Order Type"
                    rules={[{ required: true }]}
                    className="selectForm"
                  >
                    <Select placeholder="Select" suffixIcon={<DownArrowDraw />}>
                      {orderTypeData.map((orderType) => (
                        <Option key={orderType}>{orderType}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Grain</h5>
                    <p>The order can be of long or short grain</p>
                  </div>
                  <Form.Item
                    name="Grade Alias"
                    rules={[{ required: true }]}
                    className="selectForm"
                  >
                    <Select
                      placeholder={"Select"}
                      suffixIcon={<DownArrowDraw />}
                    >
                      {grainTypeData.map((grainType) => (
                        <Option key={grainType}>{grainType}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>Order Dimension</h5>
                    <p>
                      The width and length of the order <br />
                      The width of the order
                    </p>
                  </div>
                  <Row className="centerAlign justifyCSBetween">
                    <Col span={8}>
                      <div
                        className="boxFormType"
                        style={{ marginBottom: "0" }}
                      >
                        <Form.Item
                          label="Length"
                          name="Length"
                          rules={[{ required: true }]}
                          className="dBlock"
                        >
                          <Input placeholder="Length" />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={8}>
                      <div className="boxFormType">
                        <Form.Item
                          label="Width"
                          name="Width"
                          rules={[{ required: true }]}
                          className="dBlock"
                        >
                          <Input placeholder="Width" />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={7}>
                      <div className="boxFormType unitSelect">
                        <Form.Item
                          label="Unit"
                          name="Unit"
                          rules={[{ required: true }]}
                          className="dBlock"
                        >
                          <Select
                            placeholder="Unit"
                            suffixIcon={<DownArrowDraw />}
                          >
                            {deckleWidthUnitData.map((deckleWidth) => (
                              <Option
                                key={deckleWidth.value}
                                value={deckleWidth.value}
                              >
                                {deckleWidth}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Order Weight</h5>
                    <p>Weight of order in Tonnes</p>
                  </div>
                  <Form.Item
                    name="Weight"
                    rules={[{ required: true }]}
                    className=""
                  >
                    <Input placeholder="Enter weight" />
                  </Form.Item>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Quantity</h5>
                    <p>Number of reels/sheets</p>
                  </div>
                  <Form.Item
                    name="Quantity"
                    rules={[{ required: true }]}
                    className=""
                  >
                    <Input placeholder="Enter quantity" />
                  </Form.Item>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Number of Rewinder Reels</h5>
                    <p>The number of reels required to fulfill the order</p>
                  </div>
                  <Form.Item
                    name="Reels"
                    rules={[{ required: true }]}
                    className=""
                  >
                    <Input placeholder="Enter the number of reels" />
                  </Form.Item>
                </div>
                <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>Rewinder Dimensions</h5>
                    <p>The outer diameter of the reel and rewinder core</p>
                  </div>
                  <Col span={24}>
                    <Row className="centerAlign  justifyCSBetween">
                      <Col span={8} className="blockBreak">
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <Form.Item
                            label="Core OD"
                            name="Core OD"
                            rules={[{ required: true }]}
                            className="dBlock"
                          >
                            <Input placeholder="For Core OD" />
                          </Form.Item>
                        </div>
                      </Col>
                      <Col span={8} className="blockBreak">
                        <div className="boxFormType">
                          <Form.Item
                            label="Reel OD"
                            name="Reel OD"
                            rules={[{ required: true }]}
                            className="dBlock"
                          >
                            <Input placeholder="For Reel OD" />
                          </Form.Item>
                        </div>
                      </Col>
                      <Col span={7} className="blockBreak">
                        <label className="labelSel">Unit</label>
                        <div className="boxFormType unitSelect">
                          <Select
                            label="Unit"
                            placeholder="Unit"
                            suffixIcon={<DownArrowDraw />}
                            className="dBlock"
                          >
                            {deckleWidthUnitData.map((deckleWidth) => (
                              <Option
                                key={deckleWidth.value}
                                value={deckleWidth.value}
                              >
                                {deckleWidth}
                              </Option>
                            ))}
                          </Select>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
                <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>Price</h5>
                    <p>Price/Tonne of the order</p>
                  </div>
                  <Row className="centerAlign  justifyCSBetween">
                    <Col span={8}>
                      <div
                        className="boxFormType"
                        style={{ marginBottom: "0" }}
                      >
                        <Form.Item
                          label="Price"
                          name="Price"
                          rules={[{ required: true }]}
                          className="dBlock"
                        >
                          <Input placeholder="Price per Tonne" />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={8}>
                      <label className="labelSel">Currency</label>
                      <div className="boxFormType unitSelect">
                        <Select
                          placeholder="Currency"
                          suffixIcon={<DownArrowDraw />}
                        >
                          {currencyUnitData.map((currencyUnit) => (
                            <Option
                              key={currencyUnit.value}
                              value={currencyUnit.value}
                            >
                              {currencyUnit}
                            </Option>
                          ))}
                        </Select>
                      </div>
                    </Col>
                    <Col span={7}>
                      <div className="boxFormType">
                        <Form.Item
                          label="Net Price"
                          name="Net Price"
                          rules={[{}]}
                          className="dBlock"
                        >
                          <Input placeholder="Net Price" disabled />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Delivery Date</h5>
                    <p>Date when order needs to be delivered</p>
                  </div>
                  <div className="boxFormType">
                    <DatePickerY>
                      <Form.Item name="Date">
                        <DatePicker format={"DD/MM/YYYY"} />
                      </Form.Item>
                    </DatePickerY>
                  </div>
                </div>
                <div className="drawerField" style={{ paddingBottom: "20px" }}>
                  <div className="titleWithText">
                    <h5>Delivery Address</h5>
                    <p>The postal address where order needs to be delivered</p>
                  </div>

                  <Col span={24}>
                    <Row className="centerAlign">
                    <DeliveryaddressSpacing>
                      <Col span={24} className="blockBreak haberdeliveryaddress">
                        <div className="boxFormType">
                          <Form.Item
                            name="Contactaddress"
                            rules={[{ required: true }]}
                            className=""
                          >
                            <GlobalSet>
                              <div className="checklist-address">
                                <Checkbox
                                  type="checkbox"
                                  value={checkedBox}
                                  onChange={onChangeHandlerBox}
                                />
                                <p
                                  style={{
                                    fontSize: 14,
                                    fontWeight: 100,
                                  }}
                                >
                                  The order address is same as PO address
                                </p>
                              </div>
                            </GlobalSet>
                            <DisabledStyles>
                              <Input
                                disabled={checkedBox}
                                className="disabled-check"
                                placeholder="First Line of address"
                              />
                            </DisabledStyles>
                          </Form.Item>
                        </div>

                        <div className="boxFormType">
                          <Form.Item
                            name="contact address"
                            rules={[{}]}
                            className=""
                          >
                            <DisabledStyles>
                              <Input
                                disabled={checkedBox}
                                className="disabled-check"
                                placeholder="Second Line of address"
                              />
                            </DisabledStyles>
                          </Form.Item>
                        </div>

                        <Col span={12} className="d-flex">
                          <div className="boxFormType">
                            <DisabledStyles>
                              <Select
                                className="disabled-check"
                                disabled={checkedBox}
                                suffixIcon={<DownArrowDraw />}
                                defaultValue={provinceData[0]}
                                onChange={handleProvinceChange}
                              >
                                {provinceData.map((province) => (
                                  <Option key={province}>{province}</Option>
                                ))}
                              </Select>
                            </DisabledStyles>
                          </div>
                          <div className="boxFormType">
                            <DisabledStyles>
                              <Select
                                disabled={checkedBox}
                                suffixIcon={<DownArrowDraw />}
                                value={secondCity}
                                onChange={onSecondCityChange}
                              >
                                {cities.map((city) => (
                                  <Option key={city}>{city}</Option>
                                ))}
                              </Select>
                            </DisabledStyles>
                          </div>
                        </Col>
                        <Col span={12} className="d-flex">
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="City"
                              rules={[{ required: true }]}
                              className=""
                            >
                              <DisabledStyles>
                                <Input
                                  placeholder="City"
                                  disabled={checkedBox}
                                  className="disabled-check"
                                />
                              </DisabledStyles>
                            </Form.Item>
                          </div>
                          <div className="boxFormType">
                            <Form.Item
                              name="Zip code"
                              rules={[{ required: true }]}
                              className=""
                            >
                              <DisabledStyles>
                                <Input
                                  disabled={checkedBox}
                                  className="disabled-check"
                                  placeholder="ZIP code"
                                />
                              </DisabledStyles>
                            </Form.Item>
                          </div>
                        </Col>
                      </Col>
                      </DeliveryaddressSpacing>
                    </Row>
                  </Col>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Remarks</h5>
                    <p>Any other Information related to the order</p>
                  </div>
                  <Form.Item
                    name="Grade Alias"
                    rules={[{ required: true }]}
                    className=""
                  >
                    <TextArea
                      maxLength={100}
                      style={{ height: 90 }}
                      placeholder="Add Remarks"
                    />
                  </Form.Item>
                </div>
                <div className="buttonFlex fixedBtm">
                  <Form.Item>
                    <Button
                      htmlType="submit"
                      className="themeBtn"
                      onClick={props.onClose}
                    >
                      <Iconmoon icon="export" size={16} color="#ffffff" /> Go
                      to PO page{" "}
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  );
};

export default ViewApprovalOrderDrawer;
